export default __webpack_public_path__ + "static/media/liberty.39f57ec9.jpeg";